import mapDate from './mapDate';

export const putDatumyOdDoToArray = (
  datumOd?: Date,
  datumDo?: Date,
): string[] => {
  if (datumOd && datumDo) {
    return [`od ${mapDate(datumOd)}`,
      `do ${mapDate(datumDo)}`];
  }
  if (datumOd) {
    return [`od ${mapDate(datumOd)}`];
  }
  if (datumDo) {
    return [`do ${mapDate(datumDo)}`];
  }
  return [];
};
